export class ExportParams {
    lang: string;
    openTestUuid: string;
    loopUuid: string;
    sendMail: boolean;
    recipient: string;

}